import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { useBlockProps, BlockControls, InspectorControls } from '@wordpress/block-editor';
import { ToolbarGroup, ToolbarButton, Button,PanelBody, RangeControl, Flex } from '@wordpress/components';
import { alignLeft, alignCenter, alignRight } from '@wordpress/icons';
import block from './block.json';
import { useState } from 'react';

registerBlockType(block.name, {
    edit: ({ attributes, setAttributes }) => {
        const { iconSize, alignment } = attributes;

        const [isOpen, setIsOpen] = useState(false);

        const open = () => setIsOpen(true);
        const close = () => setIsOpen(false);

        const blockProps = useBlockProps({
            className: `social-share-align-${alignment}`,
            style: { 
                fontSize: `${iconSize}px`
            }
        });

        const onChangeAlignment = (newAlignment) => {
            setAttributes({ alignment: newAlignment });
        };

        const onChangeIconSize = (newSize) => {
            setAttributes({ iconSize: newSize });
        };
          

        return (
            <>
                <BlockControls>
                    <ToolbarGroup>
                        <ToolbarButton
                            icon={alignLeft}
                            title={__('Align left', 'social-share')}
                            onClick={() => onChangeAlignment('left')}
                            isActive={alignment === 'left'}
                        />
                        <ToolbarButton
                            icon={alignCenter}
                            title={__('Align center', 'social-share')}
                            onClick={() => onChangeAlignment('center')}
                            isActive={alignment === 'center'}
                        />
                        <ToolbarButton
                            icon={alignRight}
                            title={__('Align right', 'social-share')}
                            onClick={() => onChangeAlignment('right')}
                            isActive={alignment === 'right'}
                        />
                    </ToolbarGroup>
                </BlockControls>

                <InspectorControls>
                    <PanelBody title={__('Icon Settings', 'social-share')}>
                    <RangeControl
                        label={__('Icon Size', 'social-share')}
                        value={iconSize}
                        onChange={onChangeIconSize}
                        min={16}
                        max={48}
                        step={2}
                        __nextHasNoMarginBottom={true}
                    />
                    </PanelBody>
                </InspectorControls>
                
                <div {...blockProps}>
                    <Button onClick={open} className="share-button">
                            <span class="dashicons dashicons-share"></span> Share
                    </Button>
                    {isOpen && (
                            <div className="social-share-buttons" style={{ fontSize: `${iconSize}px` }}>
                                <a href="#facebook" className="social-share-button facebook">
                                    <span className="dashicons dashicons-facebook-alt"></span>
                                </a>
                                <a href="#x" className="social-share-button x">
                                    <span className="dashicons dashicons-x">&#x1D54F;</span>
                                </a>
                                <a href="#linkedin" className="social-share-button linkedin">
                                    <span className="dashicons dashicons-linkedin"></span>
                                </a>
                                <a href="#pinterest" className="social-share-button pinterest">
                                    <span className="dashicons dashicons-pinterest"></span>
                                </a>
                                <button className="social-share-button copy-link">
                                    <span className="dashicons dashicons-admin-links"></span>
                                </button>
                                <Button 
                                    onClick={close}
                                    className="social-share-close-editor-button"
                                    style={{ fontSize: '24px' }}
                                    icon="no-alt" 
                                    label={__('Close', 'social-share')}
                                />
                            </div>
                    )}
                </div>
            </>
        );
    },
    save: () => null
});

